import { type VirtualTableColumn, Checkbox } from "@snapchat/snap-design-system";
import { Header } from "../../common/components/table/Header";
import { LensIcon } from "../../common/components";
import { TwoLineCell } from "../../common/components/table/TwoLineCell";
import { DecreaseText } from "../../common/components/text";
import { formatMediumDateTime } from "../../common/formatters";
import { LensStatusCell } from "../../groups/group-details/components/group-lenses-table/LensStatusCell";
import { LensListItemModel } from "../models";
import { ActionDisabledTooltip } from "../../common/components/ActionDisabledTooltip";
import { Right } from "./AddLensesTableColumns.styles";

// Unfortunately SDS doesn't export this interface
interface CellRenderer {
    row: {
        index: number;
    };
    data: Readonly<LensTableItem[]>;
}

function getRenderer(fn: (item: LensTableItem) => JSX.Element) {
    return ({ row, data }: CellRenderer) => fn(data[row.index] as LensTableItem);
}

export interface LensTableItem {
    lens: LensListItemModel;
    selected: boolean;
    alreadySelected: boolean;
}

interface AddLensesTableProps {
    onToggleSelection: (lens: LensListItemModel) => void;
}

export function getColumns({ onToggleSelection }: AddLensesTableProps): VirtualTableColumn<LensTableItem>[] {
    return [
        {
            id: "checkbox",
            width: 50,
            Cell: getRenderer(({ lens, selected, alreadySelected }) => (
                <Right>
                    <ActionDisabledTooltip placement="top" hasMusic={lens.hasMusic}>
                        <Checkbox
                            onChange={() => onToggleSelection(lens)}
                            value={alreadySelected || selected}
                            disabled={alreadySelected || lens.hasMusic}
                        />
                    </ActionDisabledTooltip>
                </Right>
            )),
        },
        {
            id: "icon",
            width: 56,
            Header: <Header>Icon</Header>,
            Cell: getRenderer(({ lens }) => (
                <LensIcon size={40} src={lens.iconUrl} source={lens.lensSourceInfo.name as string} />
            )),
        },
        {
            id: "name",
            width: 256,
            Header: <Header>Name / ID</Header>,
            Cell: getRenderer(({ lens }) => <TwoLineCell text={lens.name} subText={lens.compoundId.id as string} />),
        },
        {
            id: "lastUpdated",
            width: 200,
            Header: <Header>Last Updated</Header>,
            Cell: getRenderer(({ lens }) => <DecreaseText>{formatMediumDateTime(lens.updatedAt)}</DecreaseText>),
        },
        {
            id: "status",
            width: 85,
            Header: <DecreaseText>Status</DecreaseText>,
            Cell: getRenderer(({ lens }) => <LensStatusCell status={lens.lensStatus as string} />),
        },
    ];
}
